/*
* XNGAGE CONFIDENTIAL
* __________________________
*
* Copyright (C) 2023 Xngage - All Rights Reserved
*
* All code or information contained herein is, and remains the
* property of Xngage LLC and its customers.  The intellectual
* and technical concepts contained are proprietary to Xngage LLC
* and may be covered by U.S. and Foreign Patents, patents in
* process, and are protected by trade secret or copyright law.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Xngage LLC.
*/

import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { getUnitRegularPrice } from "@insite/client-framework/Services/Helpers/ProductPriceService";
import { getWishListLinesDataView, isWishListLineDiscontinued, isWishListLineRestricted } from "@insite/client-framework/Store/Data/WishListLines/WishListLinesSelectors";

export function xngGetWishListTotal(
    wishListLinesDataView: ReturnType<typeof getWishListLinesDataView>,
    productInfosByWishListLineId: SafeDictionary<ProductInfo>,
) {
    if (!wishListLinesDataView.value) {
        return undefined;
    }

    let total = 0;
    wishListLinesDataView.value.forEach(wishListLine => {
        const productInfo = productInfosByWishListLineId[wishListLine.id];
        if (
            !productInfo ||
            !productInfo.pricing ||
            wishListLine.quoteRequired ||
            isWishListLineDiscontinued(wishListLine, productInfo) ||
            isWishListLineRestricted(wishListLine, productInfo)
        ) {
            return;
        }

        total +=
            Math.round(
                getUnitRegularPrice(productInfo.pricing, productInfo.qtyOrdered).price * productInfo.qtyOrdered * 100,
            ) / 100;
    });

    return total;
}
